import React from 'react';
import { PropTypes } from 'prop-types';
import { FormattedMessage } from 'react-intl';

const TooltipCursor = ({ styles, messageId, isTestimonial }) => (
    <div className={isTestimonial ? styles.testimonialContainer : styles.container}>
        <FormattedMessage id={messageId} />
    </div>
);

TooltipCursor.propTypes = {
    styles: PropTypes.shape({
        container: PropTypes.string.isRequired,
    }).isRequired,
    messageId: PropTypes.string.isRequired,
    isTestimonial: PropTypes.bool.isRequired,
};

TooltipCursor.defaultProps = {
    isTestimonial: false,
};

export default TooltipCursor;
